module.exports = __webpack_public_path__ + "c118beb2f6cc33ea.svg";